import type { IJsonApiQuery } from './jsonapi-types';

export type StrictHTTPVerb = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'OPTIONS' | 'HEAD';
export type HTTPVerb =
  | 'GET'
  | 'POST'
  | 'PUT'
  | 'DELETE'
  | 'PATCH'
  | 'OPTIONS'
  | 'HEAD'
  | 'get'
  | 'post'
  | 'put'
  | 'delete'
  | 'patch'
  | 'options'
  | 'head';

export interface HTTPVerbStrictMap {
  GET: 'GET';
  POST: 'POST';
  PUT: 'PUT';
  DELETE: 'DELETE';
  PATCH: 'PATCH';
  OPTIONS: 'OPTIONS';
  HEAD: 'HEAD';
  get: 'GET';
  post: 'POST';
  put: 'PUT';
  delete: 'DELETE';
  patch: 'PATCH';
  options: 'OPTIONS';
  head: 'HEAD';
}

export function strictifyHttpVerb<K extends keyof HTTPVerbStrictMap>(
  notStrict: K
): HTTPVerbStrictMap[K] {
  return `${notStrict}`.toUpperCase() as HTTPVerbStrictMap[K];
}

export type EmberDataRequestType =
  | 'findRecord'
  | 'findAll'
  | 'query'
  | 'queryRecord'
  | 'findMany'
  | 'findHasMany'
  | 'findBelongsTo'
  | 'createRecord'
  | 'updateRecord'
  | 'deleteRecord';

export type Hook<IN, OUT> = (payload: IN) => OUT;
export type HookClass<IN, OUT> = (payload: IN, out: OUT) => OUT;

export interface ApiCommand {
  _cmd: string;

  [key: string]: any;
}

export interface ResourceApiCommand extends ApiCommand {
  entityId: string;
  version: number;
}

export interface ApiCommandOptions<IN, OUT> {
  ajaxOptions?: any;
  before?: (i: IN) => IN;
  after?: (i: IN, o: OUT) => OUT;
  query?: IJsonApiQuery;
}

export interface ApiCollectionCommandOptions<IN, OUT> {
  ajaxOptions?: any;
  before?: (i: IN) => IN;
  after?: (i: IN, o: OUT) => OUT;
  queryParams?: Record<string, string>;
}

export interface IHeaders {
  'X-Requested-With': string;

  [key: string]: string;
}
